import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-ai-chatbot-modal',
    templateUrl: './ai-chatbot-modal.component.html',
    styleUrls: ['./ai-chatbot-modal.component.scss'],
    standalone: false
})
export class AiChatbotModalComponent {
  @Input() campaignName: string;

  constructor(public activeModal: NgbActiveModal) {}

  continue(): void {
    this.activeModal.close('continue');
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
